module.exports = __webpack_public_path__ + "img/point_detail_bg_foot.614a9921.png";